"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckinSocketEvent = void 0;
var CheckinSocketEvent;
(function (CheckinSocketEvent) {
    CheckinSocketEvent["JoinRoom"] = "checkin:joinRoom";
    CheckinSocketEvent["LeaveRoom"] = "checkin:leaveRoom";
    CheckinSocketEvent["Updated"] = "checkin:updated";
})(CheckinSocketEvent || (exports.CheckinSocketEvent = CheckinSocketEvent = {}));
